import React from 'react';
import { Helmet } from 'react-helmet';
import { Redirect } from 'react-router-dom';

import CardLayout from '@magoosh/layouts/card';
import { paths } from 'config/path_helpers';

import { useAppContext } from '@test_prep/app/context';
import { useQueries } from '@test_prep/app/queries';
import ContextualLink from '@test_prep/app/components/contextual_link';

import TOEFLDashboard from './toefl';

interface Props {}

const Dashboard: React.FC<Props> = (props) => {
  const { branding } = useAppContext().data;
  const q = useQueries();

  const page = q.pageQuery(paths.dashboard()).data;

  const breadcrumbs = [
    { name: branding.examName, path: paths.dashboard() },
    { name: 'Home' }
  ];

  return (
    <>
      <Helmet>
        <title>Dashboard - Magoosh {branding.examName}</title>
      </Helmet>

      <CardLayout breadcrumbs={breadcrumbs} loading={!page} notices={page?.ui?.notices}>
        {({ loading }) => {
          if (loading) return;

          if (branding.examName === 'TOEFL') {
            return <TOEFLDashboard { ...page } />;
          }
        }}
      </CardLayout>
    </>
  );
};

export default Dashboard;
